var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-record" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "filter-container" },
          [
            _c(
              "el-form",
              {
                ref: "queryForm",
                attrs: {
                  model: _vm.queryParams,
                  "label-width": "90px",
                  size: "small",
                  inline: "",
                },
              },
              [
                _c("div", { staticClass: "filter-form" }, [
                  _c(
                    "div",
                    { staticClass: "filter-default" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "服务单元" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: {
                                placeholder: "请选择服务单元",
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryParams.unit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "unit", $$v)
                                },
                                expression: "queryParams.unit",
                              },
                            },
                            _vm._l(_vm.unitOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "查询日期" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              type: "datetime",
                              placeholder: "选择开始时间",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.handleStartTimeChange },
                            model: {
                              value: _vm.startTime,
                              callback: function ($$v) {
                                _vm.startTime = $$v
                              },
                              expression: "startTime",
                            },
                          }),
                          _vm._v(" "),
                          _vm.endTime
                            ? _c("span", { staticClass: "time-range-tip" }, [
                                _vm._v(
                                  "（结束时间：" + _vm._s(_vm.endTime) + "）"
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "日志级别" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: {
                                placeholder: "请选择日志级别",
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryParams.level,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "level", $$v)
                                },
                                expression: "queryParams.level",
                              },
                            },
                            _vm._l(_vm.levelOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "设备号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              placeholder: "请输入设备号",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.grepString,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "grepString", $$v)
                              },
                              expression: "queryParams.grepString",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleFilter },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.resetQuery },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-buttons" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "自动刷新",
                              "inactive-text": "手动模式",
                              "active-color": "#67C23A",
                              "inactive-color": "#E6E8EB",
                            },
                            on: { change: _vm.handleSwitchChange },
                            model: {
                              value: _vm.isAutoRefresh,
                              callback: function ($$v) {
                                _vm.isAutoRefresh = $$v
                              },
                              expression: "isAutoRefresh",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-input-number", {
                            staticStyle: {
                              width: "100px",
                              "margin-left": "10px",
                            },
                            attrs: {
                              min: 10,
                              max: 60,
                              size: "small",
                              placeholder: "秒",
                              disabled: _vm.isAutoRefresh,
                            },
                            model: {
                              value: _vm.refreshInterval,
                              callback: function ($$v) {
                                _vm.refreshInterval = $$v
                              },
                              expression: "refreshInterval",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "interval-unit" }, [
                            _vm._v("秒"),
                          ]),
                          _vm._v(" "),
                          _vm.isAutoRefresh
                            ? _c("span", { staticClass: "refresh-tip" }, [
                                _vm._v(
                                  "已开启自动刷新，" +
                                    _vm._s(_vm.refreshInterval) +
                                    "秒/次"
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.logList, border: "", height: 650 },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "index",
                    label: "序号",
                    width: "80",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.$index + 1) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "日志内容", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "log-content",
                              class: {
                                "highlight-duplicate": _vm.isDuplicateLog(
                                  scope.row[0]
                                ),
                              },
                            },
                            [_vm._v(_vm._s(scope.row[0]))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }